export const updateRecordingVisibility = async recordingVisible => {
  const response = await fetch('/update-recording-visibility', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ recordingVisible }),
  });

  if (response.status !== 200) throw new Error();
};
